import { render, staticRenderFns } from "./RemitoIndividual.vue?vue&type=template&id=24f1b817"
import script from "./RemitoIndividual.vue?vue&type=script&lang=js"
export * from "./RemitoIndividual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports